





























































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Action } from '@/api/model/action'
import { User } from '@/api/model/user'
import { TooltipAlign } from '@/components/ui/Tooltip.vue'

@Component
export default class ActionCard extends Vue {
    @Prop({ required: true }) action!: Action
    @Prop({ type: Boolean, required: true }) canEdit: boolean
    hoveringOverCard: boolean = false

    get canEditAction(): boolean {
        if (!this.$currentCompany || !this.action) {
            return false
        }

        if (this.isFromRealworks) {
            return false
        }

        if (this.action.assignedTo.length > 0) {
            return this.action.assignedTo.some((user: User) => {
                if (!user.company) {
                    return false
                }

                return this.$currentCompany.id === user.company.id
            })
        }

        return this.canEdit
    }

    get hasComment(): boolean {
        return this.action.comment && this.action.comment.length > 0
    }

    get isFromRealworks(): boolean {
        return this.action.source && this.action.source === 'realworks'
    }

    get tooltipAlign(): TooltipAlign {
        return TooltipAlign.RIGHT
    }

    colorForActionType(action: Action): string {
        switch (action.type) {
            case 'meeting': return 'kvUnitedBlue'
            case 'email': return 'vueOrange'
            case 'call': return 'vueViolet'
            case 'reminder': return 'pink'
            case 'letter': return 'indigo'
            case 'billing': return 'green'
            case 'update': return 'teal'
            case 'notification': return 'vliegBlauw'
            default: return 'blue'
        }
    }

    getClassesForRealworksStatus(realworksStatus: string): object {
        switch (realworksStatus) {
            case 'Definitief':
                return { 'bg-green-200': true, 'text-green-600': true }
            case 'Wacht op bev':
                return { 'bg-orange-200': true, 'text-orange-600': true }
            case 'Geannuleerd':
                return { 'bg-red-200': true, 'text-red-600': true }
            case 'Nagebeld':
                return { 'bg-pink-200': true, 'text-pink-500': true }
            case 'Gereed':
                return { 'bg-green-200': true, 'text-green-600': true }
            case 'Lopend':
                return { 'bg-gray-200': true, 'text-gray-600': true }
            case 'Wacht':
                return { 'bg-orange-200': true, 'text-orange-600': true }
            default:
                return { 'bg-gray-200': true, 'text-gray-600': true }
        }
    }

    get sortedUsers() {
        // Get users
        const assignedUsers = [...this.action.assignedTo]

        // Sort users (current user first, other users by name)
        return assignedUsers
            .sort((a: User, b: User) => {
                if (a.id === this.$currentUser.id) {
                    return -1
                }

                if (b.id === this.$currentUser.id) {
                    return 1
                }

                return a.name.localeCompare(b.name)
            })
    }
}
